import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeviceState } from '@store/state/device.state';

export const deviceState = createFeatureSelector<DeviceState>('deviceState');

export const selectCurrentDevice = createSelector(deviceState, (state) => state.currentDevice);
